import { __rest } from "tslib";
import React from 'react';
export var WidgetComponent = function WidgetComponent(_a) {
  var WIDGETS_MAPPER = _a.WIDGETS_MAPPER,
    WIDGETS_MAPPER_V2 = _a.WIDGETS_MAPPER_V2,
    widget = _a.widget,
    rest = __rest(_a, ["WIDGETS_MAPPER", "WIDGETS_MAPPER_V2", "widget"]);
  var WidgetComp = null;
  if (WIDGETS_MAPPER_V2 && widget && widget.name && WIDGETS_MAPPER_V2[widget.name]) {
    WidgetComp = WIDGETS_MAPPER_V2[widget.name];
  } else {
    WidgetComp = WIDGETS_MAPPER[widget.templateName];
  }
  return WidgetComp ? /*#__PURE__*/React.createElement(WidgetComp, Object.assign({}, widget, rest)) : null;
};
export default WidgetComponent;